import { format, parseISO, roundToNearestMinutes } from 'date-fns';

export const roundAndParseReleaseDateTime = (dateTime: string) => {
	return roundToNearestMinutes(parseISO(dateTime), { nearestTo: 15, roundingMethod: 'ceil' });
};

export const formatRoundAndParseReleaseDateTime = (dateTime: string) => {
	return format(roundAndParseReleaseDateTime(dateTime), 'yyy-MM-dd HH:mm');
};
